import React from 'react'

interface IcCalendarProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  style?: React.CSSProperties
}

const IcCalendar: React.FC<IcCalendarProps> = ({
  width = '16px',
  height = '16px',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        d="M5.11111 4.38889V1.5M10.8889 4.38889V1.5M4.38889 7.27778H11.6111M2.94444 14.5H13.0556C13.8533 14.5 14.5 13.8533 14.5 13.0556V4.38889C14.5 3.59114 13.8533 2.94444 13.0556 2.94444H2.94444C2.1467 2.94444 1.5 3.59114 1.5 4.38889V13.0556C1.5 13.8533 2.1467 14.5 2.94444 14.5Z"
        stroke="#007AFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcCalendar
